import i11 from '../../img/burger/11.jpg'
import i12 from '../../img/burger/12.jpg'
import i13 from '../../img/burger/13.jpg'
import i14 from '../../img/burger/14.jpg'
import i15 from '../../img/burger/15.jpg'
import i16 from '../../img/burger/16.jpg'

export const burger=[
    {
        "id" : 11 ,
        "title" : "ژامبو برگر",
        "price":"250",
        "desciption":"برگر 160گرم ، ژامبون گوشت تنوری ، قارچ و پنیر گودا        ",
        "image" : i11
    },
    {
        "id" : 12 ,
        "title" : "برگر با فیله مرغ",
        "price":"260",
        "desciption":"برگر 160گرم ، فیله مرغ گریل شده ، قارچ و پنیر گودا        ",
        "image" : i12
    },
    {
        "id" : 13 ,
        "title" : "همبرگر",
        "price":"190",
        "desciption":"یک عدد برگر 160 گرمی ، نان گرد رومال دار کنجدی ، گوجه فرنگی ، خیار شور و کاهو        ",
        "image" : i13
    },
    {
        "id" : 14 ,
        "title" : "چیزبرگر",
        "price":"230",
        "desciption":"یک عدد برگر 160 گرمی ، یک ورق پنیر گودا ، نان گرد رومال دار کنجدی ، گوجه فرنگی ، خیار شور و کاهو        ",
        "image" : i14
    },
    {
        "id" : 15 ,
        "title" : "قارچ برگر",
        "price":"220",
        "desciption":"یک عدد برگر 160 گرمی ، قارچ ، گوجه فرنگی ، نان گرد رومال دار کنجدی ، خیار شور و کاهو        ",
        "image" : i15
    },
    {
        "id" : 16 ,
        "title" : "دابل چیز برگر",
        "price":"360",
        "desciption":"2 عدد برگر 160 گرمی ، پنیر گودا ،کاهو ، گوجه ، خیارشور ، قارچ و نان گرد رومال دار کنجدی        ",
        "image" : i16
    },
   
]